"use client";

import { FadeInIntersection } from "@/common/components";
import { NumbersSection as Numbers, NumbersSectionItem } from "@/modules/homepage/components-2/numbers-section";
import { useTranslations } from "@/services/i18n";

const numbersItemClasses = {
  wrapper: "max-md:items-center",
  descriptionWrapper: "max-md:w-2/3",
  value: "max-md:w-1/3 max-md:text-right",
};

export function NumbersSection() {
  const t = useTranslations("pages.consultations.numbers");

  return (
    <FadeInIntersection rootMargin="0px 0px -300px 0px" delay={100} asChild animation="fadeUp">
      <Numbers className="bg-foreground">
        <NumbersSectionItem
          value={t("1.value")}
          description={t("1.description")}
          note={t("1.note")}
          className="text-primary-foreground"
          classes={numbersItemClasses}
        />
        <NumbersSectionItem
          value={t("2.value")}
          description={t("2.description")}
          note={t("2.note")}
          className="text-primary-foreground"
          classes={numbersItemClasses}
        />
        <NumbersSectionItem
          value={t("3.value")}
          description={t("3.description")}
          note={t("3.note")}
          className="text-primary-foreground"
          classes={numbersItemClasses}
        />
      </Numbers>
    </FadeInIntersection>
  );
}
